module.exports = __webpack_public_path__ + "bd12a481950a0572dd4fd086e9b40b2e.MP3";